/*$(document).ready(function () {
    $('.news').on('click', '.page-navigation a', function (e) {
        var ajaxUrl = $(this).data('link');
        if (ajaxUrl !== undefined && ajaxUrl !== '') {
            e.preventDefault();
            var container = 'news-container-' + $(this).data('container');
            $.ajax({
                url: ajaxUrl,
                type: 'GET',
                success: function (result) {
                    var ajaxDom = $(result).find('#' + container);
                    $('#' + container).replaceWith(ajaxDom);
                }
            });
        }
    });
});
*/
const CONSTANTS = {
    ITEMCLASS: 'news__item--tile',
    NEWS_CONTAINER_CLASS: 'news-list-view--tiles'
};

const eventHandler = {
    loadmore: (e) => {
        e.preventDefault();
        const loadMoreLink = e.target;
        let uri = loadMoreLink.dataset.link

        loadMoreLink.disabled = true

        fetch(uri)
            .then(response => {
                return response.text()
            })
            .then(html => {
                let loadedDom = document.createElement("div");
                loadedDom.innerHTML = html;
                let loadedNewsItems = loadedDom.querySelectorAll(`.${CONSTANTS.ITEMCLASS}`);
                let parentPaginator = loadMoreLink.closest(`.${options.paginatorClass}`);
                let loadedPagination = loadedDom.querySelector(`.${options.paginatorClass}`);

                if (loadedNewsItems) {
                    loadedNewsItems.forEach(element => {
                        let image = element.querySelector("picture.sal-image");
                        if (image !== null) {
                            let sources = image.children;

                            for (let source of sources) {
                                if (source.tagName === "SOURCE") {
                                    source.srcset = source.dataset.src;
                                } else {
                                    source.src = source.dataset.src;
                                }
                            }

                            image.classList.remove('preview');
                        }
                        parentPaginator.parentNode.insertBefore(element, parentPaginator);
                    });

                    loadedPagination.addEventListener('click', eventHandler.loadmore);
                    parentPaginator.parentNode.append(loadedPagination);
                    parentPaginator.parentNode.removeChild(parentPaginator);
                }
            })
            .catch(() => {
                loadMoreLink.disabled = false
            })

    }
};

let options = {
    loadmoreClass: 'next',
    paginatorClass: 'page-navigation',
    paginatorListClass: 'pagination'
};

const loadmore = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);

        const loadMoreElements = document.querySelectorAll(`.${options.paginatorListClass} .${options.loadmoreClass} button`);
        loadMoreElements.forEach(element => {
            element.addEventListener('click', eventHandler.loadmore);
        });
    }
};

export {loadmore};
